module.exports = __webpack_public_path__ + "files/cdcec29617ba6617d11ab86f738c13a2.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/activity-1.png
// module id = 1467
// module chunks = 60